const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.65 23.65",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9d2b3"
    },
    d: "M0.587,0.057l6.529,0.621c0,0,0.869-0.027,0.383,0.457C7.011,1.624,5.833,2.801,5.833,2.801 S6.12,3.09,6.563,3.526c1.254,1.258,3.539,3.543,4.469,4.473c0,0,0.318,0.189-0.064,0.57c-0.383,0.387-2.072,2.068-2.346,2.344 c-0.268,0.273-0.475,0.057-0.475,0.057c-0.904-0.904-3.27-3.266-4.484-4.482C3.271,6.092,3.015,5.835,3.015,5.835 S2.067,6.78,1.474,7.374c-0.59,0.592-0.588-0.299-0.588-0.299S0.062,1.225,0.062,0.52C0.062,0.016,0.587,0.057,0.587,0.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9d2b3"
    },
    d: "M23.122,23.608l-6.523-0.621c0,0-0.871,0.025-0.387-0.461c0.486-0.484,1.666-1.666,1.666-1.666 s-0.287-0.285-0.727-0.723c-1.256-1.26-3.541-3.543-4.471-4.479c0,0-0.322-0.18,0.062-0.564s2.07-2.07,2.346-2.344 c0.271-0.275,0.477-0.059,0.477-0.059c0.902,0.906,3.27,3.27,4.482,4.482c0.393,0.395,0.65,0.654,0.65,0.654 s0.949-0.947,1.541-1.541c0.59-0.592,0.59,0.301,0.59,0.301s0.822,5.854,0.822,6.549C23.651,23.647,23.122,23.608,23.122,23.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9d2b3"
    },
    d: "M0.001,23.094l0.615-6.531c0,0-0.023-0.869,0.465-0.383c0.484,0.486,1.664,1.668,1.664,1.668 S3.03,17.561,3.47,17.12c1.256-1.256,3.541-3.541,4.475-4.475c0,0,0.184-0.316,0.568,0.066c0.383,0.387,2.07,2.072,2.344,2.346 c0.273,0.271,0.055,0.477,0.055,0.477c-0.906,0.904-3.266,3.27-4.48,4.486c-0.395,0.393-0.652,0.648-0.652,0.648 s0.945,0.947,1.537,1.537c0.592,0.594-0.297,0.59-0.297,0.59s-5.85,0.824-6.551,0.824C-0.042,23.62,0.001,23.094,0.001,23.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9d2b3"
    },
    d: "M23.552,0.557l-0.615,6.529c0,0,0.023,0.869-0.461,0.383c-0.49-0.49-1.668-1.664-1.668-1.664 s-0.286,0.286-0.725,0.725c-1.256,1.256-3.543,3.541-4.475,4.473c0,0-0.184,0.318-0.568-0.066s-2.068-2.066-2.346-2.34 c-0.27-0.279-0.057-0.482-0.057-0.482c0.906-0.904,3.27-3.268,4.484-4.48c0.396-0.395,0.65-0.652,0.65-0.652 s-0.943-0.945-1.537-1.539c-0.592-0.592,0.299-0.586,0.299-0.586s5.849-0.828,6.552-0.828C23.595,0.03,23.552,0.557,23.552,0.557z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.61e7b02ad05c2eb795d8bd530601058e.svg";
export { ForwardRef as ReactComponent };